import { FileItem } from '@inno-sdks/files'
import { useGetFileItem } from 'modules/desktop/modules/files-integration/api'
import { useTranslation } from 'react-i18next'

import { useItemModal } from '../../../hooks/useItemModal'

export const AudioPreview = () => {
  const { itemId } = useItemModal()
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop'
  })

  const { data: item } = useGetFileItem<FileItem>(itemId)

  if (!item?.metaData.presignedUrl) {
    return null
  }

  return (
    <audio controls controlsList='nodownload'>
      <source src={item.metaData.presignedUrl} />
      {t('audio-not-supported')}
    </audio>
  )
}
